import { Component } from '@angular/core';
import { RouterModule } from "@angular/router";
import { GeneralSidebarComponent } from '../../components/general-sidebar/general-sidebar.component';
import { LoggedInHeaderComponent } from '../../components/logged-in-header/logged-in-header.component';

@Component({
  selector: 'app-intranet',
  imports: [RouterModule, GeneralSidebarComponent, LoggedInHeaderComponent],
  templateUrl: './intranet.html',
  styleUrl: './intranet.scss',
})
export class Intranet {

}
